import React from "react";
import _ from "lodash";
import AppConstants from "../../constants/AppConstants";
import StyleUtils from "../../utils/StyleUtils";
import DesignContextUtils from "../../utils/DesignContextUtils";
import { DESIGN_CONTEXT } from "../../constants/DesignContextConstants";

const GallerySimple = (props) => {
  const style = {
    width: "100%",
    height: "100%",
  };

  let view = null;
  const { content, theme, elemProps } = props;
  const designContext = elemProps.get(DESIGN_CONTEXT);
  const { generateDesignAssetUrl } = DesignContextUtils.fromContext(designContext);

  //TODO remove once old images are cleared out of content
  if (!_.isObject(content)) {
    return (
      <div style={{ backgroundColor: "#884444", height: "100%", width: "100%" }}>
        Remove From Model
      </div>
    );
  }
  const items = content.get("items", false);
  if (!items || items.count() == 0) {
    return (
      <div style={{ backgroundColor: "#884444", height: "100%", width: "100%" }}>
        Select Images to Add
      </div>
    );
  }
  const firstImg = items.get(0);
  const url = generateDesignAssetUrl({ content: firstImg, elemProps });
  style.backgroundImage = `url(${url})`;
  style.backgroundRepeat = "no-repeat";
  const scale = elemProps.getIn(["gs", "t"], AppConstants.GRAPHIC_SCALE_FILL);

  if (!StyleUtils.hasBorderRadius(elemProps) && scale === AppConstants.GRAPHIC_SCALE_CONTAIN) {
    const shadowStyle = StyleUtils.getShadowStyle(elemProps, theme, "gallery");
    if (shadowStyle?.filter) {
      style.filter = shadowStyle.filter;
    }
  } else {
    const shadowStyle = StyleUtils.getShadowStyle(elemProps, theme);
    if (shadowStyle?.boxShadow) {
      style.boxShadow = shadowStyle.boxShadow;
    }
  }

  switch (scale) {
    case AppConstants.GRAPHIC_SCALE_FILL:
      style["backgroundSize"] = "cover";
      style["backgroundPosition"] =
        elemProps.getIn(["gs", "s"], "50") + "% " + elemProps.getIn(["gs", "s"], "50") + "%";
      break;
    case AppConstants.GRAPHIC_SCALE_CONTAIN:
      style["backgroundSize"] = "contain";
      style["backgroundPosition"] = "50%";
      break;
    case AppConstants.GRAPHIC_SCALE_STRETCH:
      style["backgroundSize"] = "100% 100%";
      style["backgroundPosition"] = "50%";
      break;
    case AppConstants.GRAPHIC_SCALE_ZOOM:
      style["backgroundSize"] = elemProps.getIn(["gs", "p"], "100") + "%";
      style["backgroundPosition"] =
        elemProps.getIn(["gs", "x"], "50") + "% " + elemProps.getIn(["gs", "y"], "50") + "%";
      break;
  }
  view = <div style={style}></div>;
  return view;
};

export default GallerySimple;
